export default __webpack_public_path__ + "static/media/arif-riyanto-vJP-wZ6hGBg-unsplash.b92e0ed6.jpg";